var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Edit',{attrs:{"id":_vm.id,"is_assignment":true,"is_picture":true}})}
var staticRenderFns = []

export { render, staticRenderFns }